import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const QuickSort = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Quick Sort"
    videos={[
      "https://www.youtube.com/embed/7h1s2SojIRw",
      "https://www.youtube.com/embed/-qOVVRIZzao",
      "https://www.youtube.com/embed/Vtckgz38QHs"
    ]}
    takeaways={[]}
    questions={[
      "Consider the following numbers 23, 34, 12, 18, 36, 34, 45, 56, 3. Using quick sort arrange them in ascending order. Explain the algorithm and time complexity for the same.",
      "Explain in detail about the Quick Sort algorithm followed by suitable example and running time description."
    ]}
    exampleVideos={[]}
  />
);
}

export default QuickSort;
